import { Suspense } from "react";
import { Outlet } from "react-router";
import { RouteFallback } from "@/src/common/components/route-fallback";

export function RootLayout() {
	return (
		<Suspense fallback={<RouteFallback />}>
			<Outlet />
		</Suspense>
	);
}
